module.exports = require("@splunk/visualizations-shared/themeUtils");